import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';

@Injectable()
export class CustomCertificateService {
  customCertificateUrl = 'api/CustomCertificate';
  constructor(private _customCertificateHttp: RestApi) { }

  getCurrentCertificate(): Observable<any> {
    return this._customCertificateHttp.get(`${this.customCertificateUrl}/getCurrentCertificate`);
  }

  updateCustomCertificate(customCertificate: any): Observable<any> {
    return this._customCertificateHttp.post(`${this.customCertificateUrl}/SaveCustomCertificate`, customCertificate);
  }
}
